import React, { useContext } from 'react';
import EDBox from '../../../../../../../../BaseComponents/EDBox/EDBox';
import EDIcon from '../../../../../../../../BaseComponents/Icon/EDIcon';
import EDTooltip from '../../../../../../../../BaseComponents/Tooltip/EDTooltip';
import ChangedMarker from '../../../../../../../../Components/ChangedMarker/ChangedMarker';
import { ModelContext } from '../../../../../../../../Model/ModelContext/ModelContext';
import { getAttributeValues } from '../../../../../Hooks/useAttributeValues';
import { BusinessDataFormContext } from '../../BusinessDataForm';

interface IProps {
  collectionName: string;
  fields: string[];
  fullWidth?: boolean;
}

const FieldGroupStatusIndicator: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const formContext = useContext(BusinessDataFormContext);
  const { avenyCollectionMap } = useContext(ModelContext);

  const editedValue = () =>
    Boolean(
      props.fields.find(
        field =>
          getAttributeValues(avenyCollectionMap, formContext, field).valueEdited
      )
    );
  const fieldValidations =
    formContext?.formState.validation.filter(
      validation =>
        validation.fieldName !== '' &&
        validation.message !== '' &&
        Boolean(props.fields.find(field => validation.fieldName === field))
    ) || [];
  let validateMessages = fieldValidations
    .filter(validation => validation.type === 'Error')
    .map(validation => validation.message);
  const missingValidations = fieldValidations
    .filter(validation => validation.type === 'MissingValue')
    .map(validation => validation.fieldName);
  if (missingValidations.length >= 3)
    validateMessages.unshift(
      `Värde krävs i ${missingValidations[0]} och ${
        missingValidations.length - 1
      } andra fält`
    );
  else if (missingValidations.length === 2)
    validateMessages.unshift(
      `Värde krävs i ${missingValidations[0]} och ${missingValidations[1]}`
    );
  else if (missingValidations.length === 1)
    validateMessages.unshift(`Värde krävs i ${missingValidations[0]}`);
  const errors = validateMessages.length > 0;
  if (!errors)
    validateMessages = fieldValidations
      .filter(validation => validation.type === 'Warning')
      .map(validation => validation.message);

  let icon: React.ReactNode = null;

  if (validateMessages.length > 0) {
    if (errors) {
      icon = <EDIcon iconType="error" color="error" />;
    } else {
      icon = <EDIcon iconType="warning" color="warning" />;
    }
  } else if (editedValue()) {
    icon = <ChangedMarker />;
  }

  const StatusIcon = () => (
    <EDTooltip
      title={
        validateMessages.length > 0 &&
        validateMessages.map((msg, i) => <div key={i}>{msg}</div>)
      }
    >
      <EDBox
        component={'span'}
        sx={{
          alignSelf: 'center',
        }}
      >
        {icon}
      </EDBox>
    </EDTooltip>
  );

  return props.fullWidth ? (
    <EDBox
      component={'span'}
      sx={{
        width: props.fullWidth ? '100%' : undefined,
      }}
    >
      <StatusIcon />
    </EDBox>
  ) : (
    <StatusIcon />
  );
};

export default FieldGroupStatusIndicator;
